import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DaterangepickerComponent } from './daterangepicker.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { NzButtonModule } from 'ng-zorro-antd';
import { DaterangepickerPipe } from './daterangepicker.pipe';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule
  ],
  exports: [DaterangepickerComponent, DatepickerComponent],
  declarations: [
    DaterangepickerComponent,
    DatepickerComponent,
    DaterangepickerPipe
]
})
export class DaterangepickerModule { }
